/**
 * Handles exporting a file
 *
 * @param name of file
 * @param data to be downloaded
 * @param type of file (xml/json)
 */
export function exportFile(
	name: string,
	data: string,
	type: "json" | "xml"
): void {
	const fileName = `${name}.${type}`;
	const blob = new Blob([decodeURIComponent(encodeURI(data))], {
		type: type === "json" ? "application/json" : "text/xml",
	});

	// Check if browser is IE
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	//@ts-ignore msSaveOrOpenBlob needed to work with ie even though mozilla doesn't recommend
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		window.navigator.msSaveOrOpenBlob(blob, fileName);
	} else {
		const a = document.createElement("a");
		a.download = fileName;
		a.href = URL.createObjectURL(blob);
		a.click();
	}
}
